module.exports = __webpack_public_path__ + "img/works_kiup_btm_m.b58f9534.png";